export * from './remote-action-settings-dialog.component';
